import {Container} from "@mui/material";
import {Route, Switch} from "react-router-dom";
import {DASHBOARD, HOME} from "./js/AppRoutes.js";


export default function Body() {
	  return (
				 <>
						<Container sx={{minHeight: "100vh", p: 2}}>
							  <Switch>
									 <Route path={HOME.path} exact component={HOME.component}/>
									 <Route path={DASHBOARD.path} component={DASHBOARD.component}/>
							  </Switch>
						</Container>
				 </>
	  );
}
